<template>
  <div id="app">
    <wit-header></wit-header>
    <transition :name="transitionName">
      <!-- <KeepAlive>
        <router-view />
      </KeepAlive> -->
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      routerIsBack: false,
    };
  },
  mounted() {
    console.log(process.env);
  },
  computed: {
    transitionName() {
      return this.routerIsBack ? "fold-right" : "fold-left";
    },
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      const toDepth = this.$route.fullPath.indexOf(to.path);
      const fromDepth = this.$route.fullPath.indexOf(from.path);
      this.routerIsBack = toDepth >= fromDepth;
      next();
    });
  },
};
</script>

<style lang="scss" scoped>
@import "./assets/css/global.scss";

#app {
  max-width: 750px;
  min-width: 350px;
  margin: 0 auto;
  background: $color-bg-a;
  overflow-x: hidden;
  height: 100%;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
}
</style>
